import { render, staticRenderFns } from "./CreateMapping.vue?vue&type=template&id=af6ed066&scoped=true&"
import script from "./CreateMapping.vue?vue&type=script&lang=js&"
export * from "./CreateMapping.vue?vue&type=script&lang=js&"
import style0 from "./CreateMapping.vue?vue&type=style&index=0&id=af6ed066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ed066",
  null
  
)

export default component.exports